<template>
  <div id="background">
    <div class="pop-up" :class="{'full-height': !simpleView}">
      <div class="title">
        <p v-if="newComponent">{{ MESSAGES.ADD_COMPONENT_TITLE }}</p>
        <p v-else>{{ MESSAGES.UPDATE_COMPONENT_TITLE }}</p>
        <button class="close-button warning focusStart" @click="close()">x</button>
      </div>
      <div class="modal">
        <component
          :is="`${this.processingField.metadata.type.toLowerCase()}-modal`"
          :metadata="this.processingField.metadata"
          :root="root"
          :state="this.state"
          :simpleView="this.simpleView"
          :limitCompType="limitCompType"
          @metadataSaved="metadataSaved($event)"
          @insertNoCompType="insertNoCompType($event)"
        >
          <p class="show-options" @click="setSimpleView(false)" v-if="simpleView">
            Show more options...
          </p>
          <p class="show-options" @click="setSimpleView(true)" v-if="!simpleView">
            Show less options...
          </p>
        </component>
        <layout-modal
          :layout="this.processingField.layout"
          :state="this.state"
          :simpleView="this.simpleView"
          @layoutSaved="layoutSaved($event)"
        >
        </layout-modal>
      </div>
      <div class="bottom" v-if="newComponent">
        <app-button class="warning" @onclick="close()">Cancel</app-button>
        <app-button class="newFocusEnd" @onclick="save()">Save</app-button>
      </div>
      <div class="bottom" v-else>
        <app-button class="warning" @onclick="deleteField()">Delete</app-button>
        <div class="bottom-right">
          <app-button @onclick="close()">Cancel</app-button>
          <app-button class="editFocusEnd" @onclick="save()">Save</app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from "../components/AppButton.vue";
import LayoutModal from "../components/LayoutModal.vue";
// FIELDS root node
import StaticModal from "../components/StaticModal.vue";
import StaticNTModal from "../components/StaticNTModal.vue";
import InputTextModal from "../components/InputTextModal.vue";
import CheckboxModal from "../components/CheckboxModal.vue";
import FileModal from "../components/FileModal.vue";
import OptionGroupModal from "../components/OptionGroupModal.vue";
import SelectModal from "../components/SelectModal.vue";
import PDICSModal from "../components/PDICSModal.vue";
import PhyAttendModal from "../components/PhyAttendModal.vue";
import AgreeTermsModal from "../components/AgreeTermsModal.vue";
// AREAS root node
import TextModal from "../components/TextModal.vue";
import PFSIModal from "../components/PFSIModal.vue";
import PFCPModal from "../components/PFCPModal.vue";
import PFRPModal from "../components/PFRPModal.vue";
import PFTSModal from "../components/PFTSModal.vue";
import PFHTModal from "../components/PFHTModal.vue";
import PFDSModal from "../components/PFDSModal.vue";
import PFRTModal from "../components/PFRTModal.vue";
import VFRTModal from "../components/VFRTModal.vue";
import PRCTModal from "../components/PRCTModal.vue";
import { Bus } from "../main";
import {
  MESSAGES,
  ALERT_TYPE,
  COMPONENT_TYPE,
  SPECIAL_COMPONENT,
  NO_COMP_TYPE,
  ROOT_NODE,
  AREA_COMP_TYPE,
} from "../mixins/constant-mixin";
import {
  validateRequiredField,
  validateTinyMceEditor,
  validateFieldName,
  validateOptions,
} from "../mixins/validation-mixin";
import { PDICS, PFSI, PFCP, PFRP, PFTS, PFHT, PFDS, PFRT, VFRT, PRCT } from "../mixins/special-component-mixin";

export default {
  name: "PopUpEditor",
  props: {
    root: {
      type: String,
    },
  },
  data() {
    return {
      // to control the field data passed to this component,
      // so it is not affected by using this.$set when changing the modal
      // this also save the data for final data
      finalData: null,
      // Need an initial value for the component v-is (when the page load)
      // the current processing field data to generate modals
      processingField: { layout: {}, metadata: { type: COMPONENT_TYPE.INPUT_TEXT } },
      dependencyList: [],
      state: {
        closing: false,
        saving: false,
      },
      focusTrapElement: {
        firstElement: null,
        lastElement: null,
      },
      // indicate the current processing component is a newly added component
      newComponent: false,
      // indicate the current processing form is a blank form, provide both fields and areas type
      limitCompType: null,
      // Dummy data, will change after the pop up is opened
      prevCompType: COMPONENT_TYPE.INPUT_TEXT,
      MESSAGES: MESSAGES,
      simpleView: true,
      // to track the component addition by context menu
      addByCtxMenu: false,
      SPECIAL_COMPONENT_FORMAT: {
        PDICS: PDICS,
        PFSI: PFSI,
        PFCP: PFCP,
        PFRP: PFRP,
        PFTS: PFTS,
        PFHT: PFHT,
        PFDS: PFDS,
        PFRT: PFRT,
        VFRT: VFRT,
        PRCT: PRCT,
      },
    };
  },
  components: {
    "app-button": AppButton,
    "layout-modal": LayoutModal,
    // FIELDS root node
    "static-modal": StaticModal,
    "static_nt-modal": StaticNTModal,
    "input_text-modal": InputTextModal,
    "checkbox-modal": CheckboxModal,
    "file-modal": FileModal,
    "option_group-modal": OptionGroupModal,
    "select-modal": SelectModal,
    "pdics-modal": PDICSModal,
    "phyattend-modal": PhyAttendModal,
    "agreeterms-modal": AgreeTermsModal,
    // AREAS root node
    "text-modal": TextModal,
    "pfsi-modal": PFSIModal,
    "pfcp-modal": PFCPModal,
    "pfrp-modal": PFRPModal,
    "pfts-modal": PFTSModal,
    "pfht-modal": PFHTModal,
    "pfds-modal": PFDSModal,
    "pfrt-modal": PFRTModal,
    "vfrt-modal": VFRTModal,
    "prct-modal": PRCTModal,
  },
  methods: {
    deleteField: function () {
      if (confirm(this.MESSAGES.DELETE_CONFIRMATION)) {
        this.$emit("deleteField", this.processingField.layout.seq);
        this.closePopUp();
      }
    },
    close: function () {
      if (this.newComponent) {
        if (!confirm(this.MESSAGES.CANCEL_CONFIRMATION)) {
          return;
        }
      }
      this.state = {
        closing: true,
        saving: false,
      };

      this.$nextTick(() => this.closePopUp());
    },
    save: function () {
      const validation = this.validateForm();
      if (!validation.result) {
        Bus.$emit(
          "openAlert",
          validation.message,
          ALERT_TYPE.POP_UP_EDITOR_ERROR
        );
        return;
      }

      this.state = {
        closing: true,
        saving: true,
      };

      if (
        (this.finalData.metadata.type === COMPONENT_TYPE.PDICS || 
        AREA_COMP_TYPE[this.finalData.metadata.type]) && 
        this.processingField.metadata.type !== this.finalData.metadata.type
      ) {
        this.$nextTick(() => this.$emit("checkSpecialComp"));
      }

      this.$nextTick(() => {
        if (this.newComponent) {
          // component without specific type will be added through insertNoCompType
          // they are also not editable using the creating form
          if (!this.matchNoCompType(this.processingField.metadata.type)) {
            this.$emit("addNewField", this.finalData, 1, this.addByCtxMenu);
            
            // check if it is a fields/areas specific component if the limitCompType is unset
            if (!this.limitCompType) {
              if (this.finalData.metadata.type === COMPONENT_TYPE.PDICS) {
                this.limitCompType = ROOT_NODE.FIELDS;
              } else if (AREA_COMP_TYPE[this.finalData.metadata.type]) {
                this.$emit("changeRoot", ROOT_NODE.AREAS);
                this.limitCompType = ROOT_NODE.AREAS;
              }
            }
          }
        }

        Bus.$emit("refreshLayout", this.processingField.layout.seq);
        if (this.processingField.metadata.type.includes(COMPONENT_TYPE.STATIC)) {
          this.$nextTick(() => Bus.$emit("refreshStatic", this.finalData));
        } else if (this.processingField.metadata.type === COMPONENT_TYPE.TEXT) {
          this.$nextTick(() => Bus.$emit("refreshText", this.finalData));
        } else if (this.processingField.metadata.type === COMPONENT_TYPE.PRCT) {
          this.$nextTick(() => Bus.$emit("refreshPRCT", this.finalData));
        }
        
        if (this.isUpdatingDependency(this.processingField.metadata.dependency, this.finalData.metadata.dependency)) {
          Bus.$emit("updateDependency", this.finalData);
        }

        // this.processingField = data before save (unchanged)
        // this.finalData = data after save (changed)
        if (
          (this.processingField.metadata.type === COMPONENT_TYPE.OPTION_GROUP || 
          this.processingField.metadata.type === COMPONENT_TYPE.SELECT) &&
          this.processingField.metadata.fieldName !== this.finalData.metadata.fieldName
        ) {
          this.$emit("updateDependencyParent", this.processingField.metadata.fieldName, this.finalData.metadata.fieldName);
        }

        this.$nextTick(() => this.closePopUp());
      });
    },
    // to check if the dependency is updated (is different from each other)
    // to decide is it need to emit "updateDependency" event
    isUpdatingDependency: function (dependencyBefore, dependencyAfter) {
      // no need to check if the dependency is deleted
      if (!dependencyAfter) {
        return false;
      } else if (!dependencyBefore) {
        // if have dependnecyAfter but no dependencyBefore
        return true;
      }
      // if the parent is updated or the displayIfValues is added or deleted
      if (
        dependencyBefore.parent !== dependencyAfter.parent || 
        dependencyBefore.displayIfValues.length !== dependencyAfter.displayIfValues.length
      ) {
        return true;
      }
      // compare every displayIfValues value
      for (let i = 0; i < dependencyBefore.displayIfValues.length; i++) {
        if (dependencyBefore.displayIfValues[i] != dependencyAfter.displayIfValues[i] ) {
          return true;
        }
      }

      return false;
    },
    openPopUp: function () {
      this.$el.classList.add("open");
      document.body.classList.add("disable-background");
      this.$el.querySelector(".modal").scrollTop = 0;
      this.$nextTick(() => this.setFocusTrap());
    },
    closePopUp: function () {
      this.newComponent = false;
      this.addByCtxMenu = false;
      this.simpleView = true;
      this.$el.classList.remove("open");
      document.body.classList.remove("disable-background");
      this.$el.removeEventListener("keydown", this.handleFocusTrap);
      Bus.$emit("closeAlert");
    },
    validateForm: function () {
      let validation = validateRequiredField(this.$el);
      if (!validation.result) {
        return validation;
      }

      const type = this.processingField.metadata.type.toUpperCase();
      if (type.includes(COMPONENT_TYPE.STATIC)) {
        validation = validateTinyMceEditor();
        if (!validation.result) {
          return validation;
        }
      } else if (!this.matchSpecialType(type)) {
        validation = validateFieldName(this.$el, this.processingField.metadata.type);
        if (!validation.result) {
          return validation;
        }
      }

      if (type === COMPONENT_TYPE.OPTION_GROUP || type === COMPONENT_TYPE.SELECT) {
        validation = validateOptions(this.$el);
      }
      return validation;
    },
    matchSpecialType: function (type) {
      return !!SPECIAL_COMPONENT.find(comp => comp.toUpperCase() === type.toUpperCase());
    },
    matchNoCompType: function (type) {
      return !!NO_COMP_TYPE.find(comp => comp.toUpperCase() === type.toUpperCase());
    },
    layoutSaved: function (layout) {
      this.finalData.layout = layout;
    },
    metadataSaved: function (metadata) {
      this.finalData.metadata = metadata;
    },
    insertNoCompType: function (component) {
      if (!this.newComponent) {
        this.$emit("deleteField", this.processingField.layout.seq);
      }
      let seq = this.processingField.layout.seq;
      if (component.length > 1) {
        component.forEach((comp) => {
          comp.layout.seq = seq++;
        });
      } else {
        component.layout = this.processingField.layout;
      }
      this.$emit("addNewField", component, component.length, this.addByCtxMenu);
    },
    setFocusTrap: function () {
      this.focusTrapElement.firstElement = this.$el.querySelector(".focusStart");
      this.focusTrapElement.lastElement = this.$el.querySelector(
        this.newComponent ? ".newFocusEnd" : ".editFocusEnd"
      );
      this.focusTrapElement.firstElement.focus();

      this.$el.addEventListener("keydown", this.handleFocusTrap);
    },
    handleFocusTrap: function (event) {
      const TAB_KEY = 9;
      if (event.key === "Tab" || event.keyCode === TAB_KEY) {
        if (event.shiftKey) {
          // Shift + Tab
          if (document.activeElement === this.focusTrapElement.firstElement) {
            this.focusTrapElement.lastElement.focus();
            event.preventDefault();
          }
        } else {
          // Tab
          if (document.activeElement === this.focusTrapElement.lastElement) {
            this.focusTrapElement.firstElement.focus();
            event.preventDefault();
          }
        }
      }
    },
    changeType: function (type) {
      // Replace metadata with component format when:
      // i) previous component type(before change) is different with the current type(after change)
      // ii) change type from other component type to the special type
      // iii) it has a special component type (PhyAttend/AgreeTerms additions are done by another way)
      if (type != this.prevCompType && (this.matchSpecialType(type) && !this.matchNoCompType(type))) {
        this.processingField.metadata = this.SPECIAL_COMPONENT_FORMAT[type].metadata;
      } else {
        this.clearMetadata(type);
      }
      this.processingField.metadata.type = type;
      this.simpleView = true;
      this.fieldNameInit();
    },
    setSimpleView: function (bool) {
      this.simpleView = bool;
      this.$nextTick(() => {
        if (!this.simpleView) {
          Bus.$emit("dependencyList", this.dependencyList);
          // scroll if open 'more options'
          this.$el.querySelector(".show-options").scrollIntoView();
        } else {
          this.$el.querySelector(".modal").scrollTop = 0;
        }
      });
    },
    fieldNameInit: function () {
      if (!this.processingField.metadata.fieldName && !this.processingField.metadata.type.includes(COMPONENT_TYPE.STATIC)) {
        this.$set(this.processingField.metadata, "fieldName", "");
      }
    },
    clearMetadata: function (type) {
      let options;
      if (this.processingField.metadata.options && (type === COMPONENT_TYPE.OPTION_GROUP || type === COMPONENT_TYPE.SELECT)) {
        options = this.processingField.metadata.options;
      }
      this.processingField.metadata = {};
      if (options) {
        this.processingField.metadata.options = options;
      }
    }
  },
  mounted() {
    // emit from FormComponent
    // emit from FormEditor, when click <Add Component>
    Bus.$on("openPopUp", (field, newComponent) => {
      if (newComponent) {
        this.newComponent = true;
      }
      this.finalData = field;
      this.processingField = structuredClone(field);
      this.prevCompType = field.metadata.type;
      this.fieldNameInit();

      this.openPopUp();
    });

    // emit from FormEditor, containing the list of possible parents, to pass to the DependencyEditor
    Bus.$on("getDependency", (list) => {
      this.dependencyList = list;
    });

    Bus.$on("changeType", (type) => {
      this.changeType(type);
    })

    // emit from FormEditor, when add component using contextMenu
    Bus.$on("addByCtxMenu", (field) => {
      this.newComponent = true;
      this.finalData = field;
      this.processingField = structuredClone(field);
      this.addByCtxMenu = true;
      if (!field.metadata.fieldName) {
        this.$set(this.processingField.metadata, "fieldName", "");
      }

      this.openPopUp();
    });

    // emit from FormEditor
    Bus.$on("limitCompType", (root) => {
      this.limitCompType = root;
    })
  },
  beforeDestroy() {
    Bus.$off("openPopUp");
    Bus.$off("getDependency");
    Bus.$off("changeType");
    Bus.$off("addByCtxMenu");
    Bus.$off("limitCompType");
  },
};
</script>

<style>
.disable-background {
  overflow: hidden;
}
</style>

<style scoped>
#background {
  min-width: 100vw;
  min-height: 100vh;
  background: #00000069;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  display: none;
  overflow: auto;
}

.pop-up {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 80vw;
  height: 65vh;
  border: 1px solid #000;
  background: #fff;
  box-shadow: 0px 0px 5px 1px #646464;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -60%);
}

.full-height {
  height: 85vh;
  top: 1rem;
  transform: translateX(-50%);
}

@media (max-width: 1100px) {
  .pop-up {
    width: auto;
    left: 0;
    transform: translateY(-60%);
  }
}

@media (min-width: 1300px) {
  .pop-up {
    width: 70vw;
  }
}

@media (min-width: 1600px) {
  .pop-up {
    width: 60vw;
  }
}

@media (min-width: 1900px) {
  .pop-up {
    width: 50vw;
  }
}

@media (max-height: 800px) {
  .pop-up {
    height: 70vh;
  }
}

.title {
  background: #f9f9f9;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding-left: 1rem;
  position: sticky;
  top: 0;
  font-weight: bold;
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  background: #c1c1c1;
  border: 1px solid #000;
  padding: 0px 10px 3px 10px;
  margin-top: -3px;
  font-size: 20px;
}

.modal {
  height: 100%;
  overflow: auto;
  scroll-behavior: smooth;
}

.open {
  display: block !important;
}

.show-options {
  width: fit-content;
  padding: 5px;
  margin: 0;
  margin-left: auto;
  cursor: pointer;
  color: #00e;
}

.bottom {
  position: absolute;
  bottom: -65px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: inset 0px 0px 3px 1px #969696;
  border: 1px solid #000;
}

.bottom-right {
  margin-left: auto;
}

.warning {
  background: #b80000;
  color: #fff;
}
</style>